import WordPressProvider from '@/providers/WordPressProvider';

export default {
  state: {
    vacancies: null,
    pipefyLink: null,
    commonText: null,
  },
  mutations: {
    getVacancies(state, payload) {
      state.vacancies = payload;
    },
    getPipefyLink(state, payload) {
      state.pipefyLink = payload;
    },
    getCommonText(state, payload) {
      state.commonText = payload;
    },
  },
  actions: {
    async fetchData({ commit }) {
      const promise = await WordPressProvider.getPageBySlug('trabalhe-conosco');
      const vacancies = promise.data[0].acf.job_vacancies;
      const pipefyLink = promise.data[0].acf.pipefy_link;
      const commonText = promise.data[0].acf.common_text;

      commit('getVacancies', vacancies);
      commit('getPipefyLink', pipefyLink);
      commit('getCommonText', commonText);
    },
  },
};
